export enum PanelPlansDetailSectionsEnum {
    Personalization,
    Price,
    Workflow,
    Routes
}
